/**
 * Global JS
 */

// CSS
import styles from '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import LazyLoad from 'vanilla-lazyload';

// Lib
import './lib/wl-share';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/back-to-top';
import './site/nav-mobile';
import './site/search-autosuggest';
import './site/side-nav';
import './site/vendor-contact-form-7';
import './site/mega-menu-alt';
import VideoModal from './site/video-modal';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Lazyload
const lazyLoadInstance = new LazyLoad({ elements_selector: '[data-lazy]' });

// Init Video Modal
const videoModalInstance = new VideoModal();
videoModalInstance.init();

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500,
});

const carouselTestimonial = carousels('[data-carousel="testimonial"]', {
  autoplay: true,
  dots: false,
  infinite: true,
  speed: 500
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

/* Validation Events for changing response CSS classes */
document.addEventListener(
  'wpcf7invalid',
  function(event) {
    $('.wpcf7-response-output').addClass('notice notice--red');
  },
  false
);
document.addEventListener(
  'wpcf7spam',
  function(event) {
    $('.wpcf7-response-output').addClass('notice notice--yellow');
  },
  false
);
document.addEventListener(
  'wpcf7mailfailed',
  function(event) {
    $('.wpcf7-response-output').addClass('notice notice--yellow');
  },
  false
);
document.addEventListener(
  'wpcf7mailsent',
  function(event) {
    $('.wpcf7-response-output').addClass('notice notice--green');
  },
  false
);

if ($('.wpcf7-form.invalid').length) {
  $('.wpcf7-response-output').addClass('notice notice--red');
}

if ($('.wpcf7-form.sent').length) {
  $('.wpcf7-response-output').addClass('notice notice--green');
}

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');
